<template>
  <teleport to="body">
    <div class="modal" v-if="showModal" @click.self.prevent="closed">
      <div class="wrapper">
        <div class="content">
          <font-awesome-icon icon="fa-xmark" class="exit" @click.stop.prevent="closed" />
          <h3 v-if="newStation">Create MON Station</h3>
          <h3 v-else>Edit MON Station</h3>
          <form @submit.prevent.stop>
            <div class="name">
              <h4>Station Name:</h4>
              <input
                v-if="newStation"
                type="text"
                v-model="openStation.name"
                placeholder="Station name..."
                required
              />
              <label v-else>{{ station.name }}</label>
            </div>
            <div class="action-btns">
              <button v-if="newStation" class="button create action-colour" @click="createStation">
                Create
              </button>
              <button v-else class="button action-colour" @click="updateStation">
                Update
              </button>
              <button class="button danger" v-if="!newStation" @click="deleteStation">
                Delete
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { api } from "@monolith/helpers";

export default {
  name: "MONStationModal",
  props: ["open", "station", "newStation"],
  emits: ["update", "close"],
  data() {
    return {
      showModal: false,
      openStation: {},
    };
  },
  watch: {
    open() {
      if (!this.open) {
        this.showModal = false;
        return;
      }
      this.showModal = true;
      this.openStation = { ...this.station };
    },
  },
  methods: {
    closed() {
      this.$emit("close");
      this.showModal = false;
    },
    async createStation() {
      this.$store.dispatch("loading", true);
      const station = {
        name: this.openStation.name,
        site: this.openStation.site,
        type: "mon",
      };
      await api.post("/api/company/add_station", { site: this.openStation.site, station: station, station_type: "get_mon" });
      await this.$store.dispatch("initialSiteMap");
      this.$store.dispatch("loading", false);
      this.closed();
    },
    updateStation() {
      this.$emit("update", "update", "mon", this.openStation);
    },
    deleteStation() {
      this.$emit("update", "delete", "mon", this.openStation);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

h3 {
  color: var(--text-colour);
  text-align: center;
  margin: 0.5rem;
}

form {
  .name {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
    margin: 1rem;

    h4 { margin: 0; }

    input {
      border-radius: 0.25rem;
      border: none;
      padding: 0.5rem;
    }
  }

  .action-btns {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin: 1rem auto 0;
  }
}
</style>
